/**
 * Alpenshade — Back In Stock
 *
 * The theme does NOT fully re-render the buy-buttons section on variant
 * change — it only surgically updates specific elements. So we render
 * BOTH the Add to Cart wrapper AND the BIS container in the DOM, and
 * toggle their visibility by subscribing to the theme's `variant-change`
 * pub/sub event.
 *
 * The quantity selector (rendered separately in sections/main-product.liquid)
 * is also toggled in lockstep so the entire "buy area" is consistent.
 *
 * Visibility is forced with display:none !important to override any
 * theme CSS that might otherwise keep elements visible.
 *
 * Globals provided by the theme (loaded before this script):
 *   - subscribe(eventName, callback)        (assets/pubsub.js)
 *   - PUB_SUB_EVENTS.variantChange = 'variant-change' (assets/constants.js)
 */

(function () {
  const KLAVIYO_PUBLIC_KEY = 'Xh7qRB';
  const KLAVIYO_API_URL = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_PUBLIC_KEY}`;
  const QUANTITY_SELECTOR = '[id^="Quantity-Form-"]';

  if (window.__alpenshadeBISInit) return;
  window.__alpenshadeBISInit = true;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    bindEvents();
    subscribeToVariantChange();
    syncQuantityWithCurrentState();
  }

  function bindEvents() {
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.bis-notify-trigger');
      if (!trigger) return;
      scrollToBISForm();
    });

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.bis-submit-btn');
      if (!btn) return;
      const container = btn.closest('[data-bis-container]');
      if (!container) return;
      handleBISSubmit(container);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      const input = e.target.closest('.bis-email-input');
      if (!input) return;
      e.preventDefault();
      const container = input.closest('[data-bis-container]');
      if (!container) return;
      handleBISSubmit(container);
    });
  }

  function subscribeToVariantChange() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
          if (!payload || !payload.data) return;
          handleVariantChange(payload.data.variant);
        });
        return;
      } catch (e) {
        // fall through to fallback
      }
    }

    // Fallback if theme pub/sub isn't available
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[name="id"]')) return;
      const variantId = e.target.value;
      const productInfo = e.target.closest('[id^="MainProduct-"]');
      const sectionId = productInfo ? productInfo.dataset.section : '';
      const submitButton = document.getElementById('ProductSubmitButton-' + sectionId);
      const variant = {
        id: variantId,
        available: submitButton ? !submitButton.hasAttribute('disabled') : true,
      };
      handleVariantChange(variant);
    });
  }

  function handleVariantChange(variant) {
    if (!variant) return;
    const isSoldOut = variant.available === false;

    setVisibility('[data-bis-add-to-cart]', !isSoldOut);
    setVisibility('[data-bis-container]', isSoldOut);
    setVisibility(QUANTITY_SELECTOR, !isSoldOut);

    // Update BIS variant id + reset state when becoming visible
    document.querySelectorAll('[data-bis-container]').forEach(function (container) {
      const variantInput = container.querySelector('.bis-variant-id');
      if (variantInput && variant.id) {
        variantInput.value = variant.id;
      }
      resetBISForm(container);
    });
  }

  /**
   * On initial page load the cart/BIS wrappers already have their correct
   * inline display state from Liquid. Mirror that onto the quantity selector
   * so a sold-out variant doesn't show the qty stepper.
   */
  function syncQuantityWithCurrentState() {
    const cartWrapper = document.querySelector('[data-bis-add-to-cart]');
    if (!cartWrapper) return;
    const isSoldOut = cartWrapper.style.display === 'none';
    setVisibility(QUANTITY_SELECTOR, !isSoldOut);
  }

  function setVisibility(selector, visible) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (visible) {
        // Remove display none, allow default
        el.style.removeProperty('display');
      } else {
        // Force hide with !important to beat any theme CSS
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function resetBISForm(container) {
    const formWrapper = container.querySelector('.bis-form-wrapper');
    const success = container.querySelector('.bis-success');
    const error = container.querySelector('.bis-error');
    const submitBtn = container.querySelector('.bis-submit-btn');
    const emailInput = container.querySelector('.bis-email-input');

    if (formWrapper) formWrapper.style.display = 'flex';
    if (success) success.style.display = 'none';
    if (error) {
      error.style.display = 'none';
      error.textContent = '';
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify Me';
    }
    if (emailInput) emailInput.value = '';
  }

  function scrollToBISForm() {
    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;
      const visibleContainer = Array.from(
        document.querySelectorAll('[data-bis-container]')
      ).find(function (el) { return el.style.display !== 'none'; });
      if (visibleContainer) {
        clearInterval(interval);
        const emailInput = visibleContainer.querySelector('.bis-email-input');
        if (emailInput) {
          emailInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { emailInput.focus(); }, 400);
        }
      } else if (attempts >= 20) {
        clearInterval(interval);
      }
    }, 100);
  }

  function handleBISSubmit(container) {
    const emailInput = container.querySelector('.bis-email-input');
    const variantInput = container.querySelector('.bis-variant-id');
    const submitBtn = container.querySelector('.bis-submit-btn');
    const errorEl = container.querySelector('.bis-error');
    const successEl = container.querySelector('.bis-success');
    const formWrapper = container.querySelector('.bis-form-wrapper');

    const email = emailInput && emailInput.value.trim();
    const variantId = variantInput && variantInput.value;

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }

    if (!email || !isValidEmail(email)) {
      if (errorEl) {
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.style.display = 'block';
      }
      return;
    }

    if (!variantId) {
      if (errorEl) {
        errorEl.textContent = 'Could not determine product variant. Please try again.';
        errorEl.style.display = 'block';
      }
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '...';
    }

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    fetch(KLAVIYO_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-06-15'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.ok || response.status === 202) {
          if (formWrapper) formWrapper.style.display = 'none';
          if (successEl) successEl.style.display = 'block';
        } else {
          throw new Error('Subscription failed');
        }
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify Me';
        }
        if (errorEl) {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.style.display = 'block';
        }
      });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

})();
